/* Hylo colourway swap - card thumbnail strip + controlled card hover */
(function () {
  if (window.__hyloColourwaySwap) return;
  window.__hyloColourwaySwap = true;

  var css = '' +
    /* Strip in normal flow between the image and the title, centred. */
    /* High z-index so it sits above the theme's stretched card link overlay. */
    '.product-card__colourways{display:flex;justify-content:center;align-items:center;' +
      'gap:10px;padding:6px 0 12px;position:relative;z-index:10;isolation:isolate;}' +

    '.product-card__colourway{flex:0 1 auto;width:13%;min-width:26px;max-width:58px;' +
      'padding:0;border:0;border-radius:8px;background:none;cursor:pointer;' +
      'position:relative;z-index:11;' +
      'outline:1px solid transparent;outline-offset:3px;transition:outline-color 0.15s ease;}' +

    /* Box appears on hover only - no persistent marker on the selected colourway */
    '.product-card__colourway:hover{outline-color:currentColor;}' +

    '.product-card__colourway img{display:block;width:100%;height:auto;aspect-ratio:1;object-fit:contain;border-radius:6px;pointer-events:none;}' +

    /* --- We drive the hover cross-fade ourselves, so the info/price area never triggers it. --- */
    /* is-media-hover is only ever applied when the card actually has a second image, so the */
    /* theme setting "show secondary image on hover" stays in charge of whether it happens. */
    'product-card .product-card__image--primary{opacity:1 !important;}' +
    'product-card .product-card__image--secondary{opacity:0 !important;visibility:hidden !important;}' +
    'product-card.is-media-hover .product-card__image--primary{opacity:0 !important;}' +
    'product-card.is-media-hover .product-card__image--secondary{opacity:1 !important;visibility:visible !important;}' +

    /* --- No scrim behind the info block, and never flip the text to white on hover --- */
    'product-card .product-card__info,' +
    'product-card .product-card__info::before,' +
    'product-card .product-card__info::after{background:transparent !important;background-image:none !important;box-shadow:none !important;}' +
    'product-card:hover .product-card__info,' +
    'product-card:hover .product-card__info *{color:inherit !important;}' +
    'product-card.is-swatch-hover .product-card__quick-buy{opacity:0 !important;pointer-events:none !important;}' +

    /* --- Mobile: centred slider showing 4 thumbs, smaller card text --- */
    /* padding-top gives the hover outline room inside the scroll box so it is not clipped */
    '@media screen and (max-width:699px){' +
      'product-card .product-card__colourways{justify-content:flex-start;gap:8px;padding:6px 0 10px;' +
        'width:fit-content;max-width:calc(4 * 40px + 3 * 8px + 14px);margin-inline:auto;' +
        'overflow-x:auto;overscroll-behavior-x:contain;-webkit-overflow-scrolling:touch;' +
        'touch-action:pan-x;scrollbar-width:none;-ms-overflow-style:none;}' +
      'product-card .product-card__colourways::-webkit-scrollbar{display:none;}' +
      'product-card .product-card__colourway{flex:0 0 auto;width:40px;min-width:40px;max-width:40px;' +
        'touch-action:pan-x;outline-offset:2px;border-radius:6px;}' +
      'product-card .product-card__colourway img{border-radius:4px;}' +
      'product-card .product-card__info .product-title{font-size:13px;line-height:1.25;}' +
      'product-card .product-card__info .product-card__subtitle{font-size:12px;line-height:1.3;}' +
      'product-card .product-card__info sale-price,' +
      'product-card .product-card__info compare-at-price,' +
      'product-card .product-card__info price-list{font-size:12px;}' +
    '}' +

    /* Very narrow phones */
    '@media screen and (max-width:400px){' +
      'product-card .product-card__colourways{gap:6px;max-width:calc(4 * 36px + 3 * 6px + 12px);}' +
      'product-card .product-card__colourway{width:36px;min-width:36px;max-width:36px;outline-offset:2px;}' +
      'product-card .product-card__info .product-title{font-size:12px;}' +
      'product-card .product-card__info .product-card__subtitle{font-size:11px;}' +
      'product-card .product-card__info sale-price,' +
      'product-card .product-card__info compare-at-price,' +
      'product-card .product-card__info price-list{font-size:11px;}' +
    '}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var canHover = window.matchMedia('(hover: hover)').matches;

  function setImage(img, src, src2x) {
    if (!img || !src) return;
    img.src = src;
    if (src2x) {
      img.srcset = src + ' 1x, ' + src2x + ' 2x';
    } else {
      img.removeAttribute('srcset');
    }
  }

  function applySwap(btn) {
    if (!btn || btn.classList.contains('is-selected')) return;

    var card = btn.closest('product-card');
    if (!card) return;

    // Swap main image
    var primary = card.querySelector('.product-card__image--primary');
    setImage(primary, btn.dataset.image, btn.dataset.image2x);

    // Update the hover image ONLY if the theme rendered one. We never create one:
    // if "show secondary image on hover" is off there is no second image, and adding
    // one here would override that setting.
    var secondary = card.querySelector('.product-card__image--secondary');
    if (secondary) {
      if (btn.dataset.imageHover) {
        setImage(secondary, btn.dataset.imageHover, btn.dataset.imageHover2x);
      } else {
        secondary.remove();
      }
    }

    // Point the card links at the selected colourway
    card.querySelectorAll('a.product-card__media, a.product-title').forEach(function (a) {
      if (btn.dataset.productUrl) a.href = btn.dataset.productUrl;
    });

    // Keep quick buy working: repoint the modal at the selected colourway
    var quickBuyModal = card.querySelector('quick-buy-modal');
    if (quickBuyModal && btn.dataset.productUrl) {
      quickBuyModal.setAttribute('product-url', btn.dataset.productUrl);
    } else {
      var quickBuy = card.querySelector('.product-card__quick-buy');
      if (quickBuy) quickBuy.remove();
    }

    var floatingSizes = card.querySelector('.product-card__floating-size-selector');
    if (floatingSizes) floatingSizes.remove();

    var subtitle = card.querySelector('.product-card__subtitle');
    if (subtitle && btn.dataset.subtitle) subtitle.textContent = btn.dataset.subtitle;

    // Tracked in JS only - no visual marker, matching Mount to Coast
    card.querySelectorAll('.product-card__colourway.is-selected').forEach(function (b) {
      b.classList.remove('is-selected');
    });
    btn.classList.add('is-selected');
  }

  function pointInRect(el, x, y) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  }

  // The theme stretches the card image link across the whole card, which swallows pointer
  // events. So we work out what the pointer is over geometrically rather than by event target.
  function swatchAtPoint(card, x, y) {
    if (!card || x == null || y == null) return null;

    var strip = card.querySelector('.product-card__colourways');

    // Ignore points outside the visible strip window (thumbs scrolled out of view)
    if (strip && !pointInRect(strip, x, y)) return null;

    var swatches = card.querySelectorAll('.product-card__colourway');

    for (var i = 0; i < swatches.length; i++) {
      if (pointInRect(swatches[i], x, y)) return swatches[i];
    }

    return null;
  }

  // --- Desktop hover ---
  // mousemove (not mouseover) because the stretched card link means the pointer never
  // "enters" the swatch element, so mouseover would never fire for it.
  var hoveredCard = null;
  var hoveredSwatch = null;

  document.addEventListener('mousemove', function (e) {
    if (!canHover) return;

    var card = e.target.closest ? e.target.closest('product-card') : null;

    if (!card) {
      if (hoveredCard) {
        hoveredCard.classList.remove('is-swatch-hover');
        hoveredCard.classList.remove('is-media-hover');
        hoveredCard = null;
      }
      hoveredSwatch = null;
      return;
    }

    if (hoveredCard && hoveredCard !== card) {
      hoveredCard.classList.remove('is-swatch-hover');
      hoveredCard.classList.remove('is-media-hover');
    }
    hoveredCard = card;

    var swatch = swatchAtPoint(card, e.clientX, e.clientY);
    var overFigure = pointInRect(card.querySelector('.product-card__figure'), e.clientX, e.clientY);
    var hasSecondary = !!card.querySelector('.product-card__image--secondary');

    card.classList.toggle('is-swatch-hover', !!swatch);
    card.classList.toggle('is-media-hover', hasSecondary && overFigure && !swatch);

    if (swatch && swatch !== hoveredSwatch) {
      hoveredSwatch = swatch;
      applySwap(swatch);
    } else if (!swatch) {
      hoveredSwatch = null;
    }
  });

  document.addEventListener('mouseleave', function (e) {
    var card = e.target.closest ? e.target.closest('product-card') : null;
    if (card) {
      card.classList.remove('is-swatch-hover');
      card.classList.remove('is-media-hover');
    }
  }, true);

  // Capture phase: intercept before the card link can navigate.
  // Clicking a swatch changes the colour - it never opens the product.
  document.addEventListener('click', function (e) {
    var card = e.target.closest ? e.target.closest('product-card') : null;
    if (!card) return;

    var btn = swatchAtPoint(card, e.clientX, e.clientY);
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    applySwap(btn);
  }, true);

  // --- Touch ---
  // The card link overlay can swallow touches, so the strip is scrolled manually:
  // drag horizontally to scroll it, tap to change colour. Neither ever navigates.
  var touchState = null;

  document.addEventListener('touchstart', function (e) {
    var card = e.target.closest ? e.target.closest('product-card') : null;
    if (!card) { touchState = null; return; }

    var strip = card.querySelector('.product-card__colourways');
    var touch = e.touches[0];

    if (!strip || !pointInRect(strip, touch.clientX, touch.clientY)) {
      touchState = null;
      return;
    }

    touchState = {
      strip: strip,
      btn: swatchAtPoint(card, touch.clientX, touch.clientY),
      startX: touch.clientX,
      startY: touch.clientY,
      lastX: touch.clientX,
      moved: 0,
      scrolling: false
    };
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!touchState) return;

    var touch = e.touches[0];
    var dx = touch.clientX - touchState.startX;
    var dy = touch.clientY - touchState.startY;

    touchState.moved = Math.max(Math.abs(dx), Math.abs(dy));

    if (touchState.scrolling || (Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy))) {
      touchState.scrolling = true;
      touchState.strip.scrollLeft -= touch.clientX - touchState.lastX;
      touchState.lastX = touch.clientX;

      if (e.cancelable) e.preventDefault();
    }
  }, { passive: false });

  document.addEventListener('touchend', function (e) {
    if (!touchState) return;

    if (!touchState.scrolling && touchState.moved < 10 && touchState.btn) {
      if (e.cancelable) e.preventDefault();
      applySwap(touchState.btn);
    }

    touchState = null;
  });

  document.addEventListener('touchcancel', function () {
    touchState = null;
  });
})();
